import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { HistoryService } from './history.service';


@Injectable({ providedIn: 'root' })
export class HistoryResolver implements Resolve<HttpResponse<History[]>> {
  constructor(
    private historyService: HistoryService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params.id;

    return this.historyService.getEntityHistory('lift', id);
  }
}
